<template>
  <v-dialog
    v-model="isOpenModal"
    :scrim="false"
    scrollable
    :width="$vuetify.breakpoint.mobile ? 'auto' : '50%'"
    @click:outside="confirm"
  >
    <v-card
      class="card"
      :class="$vuetify.breakpoint.mobile ? 'help-card-mobile' : ''"
      :height="$vuetify.breakpoint.mobile ? '' : '100%'"
    >
      <div class="d-flex bg-titre">
        <div
          class="d-flex pl-3 mr-auto"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
        >
          <div class="titre-h3 secondary--text align-self-center">
            Ma tréso disponible
          </div>
        </div>
      
        <v-btn
          text
          class="btn-close"
          @click="confirm()"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div :class="$vuetify.breakpoint.mobile ? 'content-mobile' : 'content'">
        <div class="d-flex justify-space-between">
          <div
            v-if="$vuetify.breakpoint.mobile"
            class="titre-h3 secondary--text"
          >
            Matrice de gain (€/ha)
          </div>
          <div
            v-else
            class="titre-h3 secondary--text"
          >
            Matrice de gain de la trésorerie disponible  (€/ha)
          </div>
          <div
            class="align-self-center ml-3"
          >
            <v-icon
              @click="isOpenModalHelp = true"
            >
              mdi-information-outline
            </v-icon>
          </div>
        </div>
        <BaseLoader v-if="!matriceGainTresorerieChargee" />

        <div
          v-else-if="matrice == null"
          class="d-flex flex-column align-center justify-center matrice-vide"
        >
          <img
            src="@/assets/no-tresorerie.svg"
            alt="no-tresorerie"
            class="mb-4"
          >
          <div class="intro texte-gris-fonce text-center">
            La matrice a besoin de votre rendement, de votre prix de vente et de votre prix d'équilibre sur cette culture. Renseignez votre récolte pour la voir.
          </div>
        </div>

        <div
          v-else
          class="ml-3 ml-md-0"
        >
          <div class="d-flex justify-center mention texte-gris-fonce mt-6">
            Prix de vente (€/t)
          </div>
          <div
            class="d-flex "
            :class="$vuetify.breakpoint.mobile ? '' : 'tableau'"
          >
            <div class="d-flex flex-column align-center mention texte-gris-fonce text-orientation-vertical">
              Rendement ({{ matrice.uniteRendement }})
            </div>
            <div :class="$vuetify.breakpoint.mobile ? 'matrice-mobile' : 'matrice'">
              <div class="d-flex">
                <div
                  class="titre case-tl"
                  :class="classeCase"
                />
                <div
                  v-for="(prixVente, indexPrixVente) in matrice.prixVente"
                  :key="`prix-${indexPrixVente}`"
                  class="titre intro texte-gris-fonce d-flex align-center justify-center"
                  :class="[classeCase, indexPrixVente === matrice.prixVente.length - 1 ? 'case-tr' : '']"
                >
                  {{ formaterEntier(prixVente) }}
                </div>
              </div>
              <div
                v-for="(rendement, indexRendement) in matrice.rendements"
                :key="`rendement-${indexRendement}`"
                class="d-flex"
              >
                <div
                  class="titre intro texte-gris-fonce d-flex align-center justify-center"
                  :class="[classeCase, estDerniereLigne(indexRendement) ? 'case-bl' : '']"
                >
                  {{ formaterRendement(rendement) }}
                </div>
                <div
                  v-for="(tresorerie, indexPrixVente) in matrice.cellules[indexRendement]"
                  :key="`case-${indexRendement}-${indexPrixVente}`"
                  class="intro d-flex align-center justify-center"
                  :class="[
                    classeCase,
                    estDerniereLigne(indexRendement) && indexPrixVente === matrice.prixVente.length - 1 ? 'case-br' : ''
                  ]"
                  :style="styleCase(tresorerie)"
                >
                  <v-menu
                    v-if="estCaseAdherent(indexRendement, indexPrixVente)"
                    content-class="elevation-0"
                    open-on-hover
                    origin="center center"
                    :nudge-left="$vuetify.breakpoint.mobile ? '' : '82'"
                    :nudge-top="$vuetify.breakpoint.mobile ? '' : '20'"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-icon
                          :size="$vuetify.breakpoint.mobile ? 16 : 20"
                          :style="{ color: styleCase(tresorerie).color }"
                          class="align-self-center mr-1"
                        >
                          mdi-account-circle
                        </v-icon>
                      </div>
                    </template>
                    <div
                      :class="$vuetify.breakpoint.mobile ? 'menu-item-resume-mobile' : 'menu-item-resume menu-item-resume__top pa-2'"
                    >
                      Ma tréso disponible
                    </div>
                  </v-menu>
                  {{ formaterEntier(tresorerie) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Matrice de gain de la trésorerie disponible (€/ha)"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-4">
          <p>Visualisez la trésorerie disponible en fonction de l'évolution du prix de vente et du rendement.</p>
          <p class="pt-1">
            Trésorerie disponible = Prix de vente (€/ha) - Prix d'équilibre (€/ha)
          </p>
        </div>
      </div>
    </HelpModal>
  </v-dialog>
</template>

<script>
import { bornesMatrice, construireMatriceGain, couleurCase, formaterEntier, formaterRendement } from '@/utils/matrice-gain'
import { mapActions, mapGetters } from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import HelpModal from '@/components/modal/help-modal.vue'

export default {
  name: 'MatriceGainModal',
  components: {BaseLoader, HelpModal},
  props: {
    isOpenModal: {
      type: Boolean,
      default: false
    },
    codeTypeCulture: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false
    }
  },
  computed: {
    ...mapGetters({
      cultures: 'culture/cultures',
      matriceGainTresorerie: 'cloture/matriceGainTresorerie',
      matriceGainTresorerieChargee: 'cloture/matriceGainTresorerieChargee'
    }),
    typeCulture () {
      return this.cultures.map(culture => culture.typeCulture).find(typeCulture => typeCulture.code === this.codeTypeCulture)
    },
    matrice () {
      return construireMatriceGain(this.matriceGainTresorerie, this.typeCulture)
    },
    bornes () {
      return this.matrice != null ? bornesMatrice(this.matrice.cellules) : null
    },
    classeCase () {
      return this.$vuetify.breakpoint.mobile ? 'case-mobile' : 'case'
    }
  },
  created () {
    this.getMatriceGainTresorerie(this.codeTypeCulture).catch(() => {})
  },
  methods: {
    ...mapActions({
      getMatriceGainTresorerie: 'cloture/getMatriceGainTresorerie'
    }),
    formaterEntier,
    formaterRendement,
    estDerniereLigne (indexRendement) {
      return this.matrice != null && indexRendement === this.matrice.rendements.length - 1
    },
    estCaseAdherent (indexRendement, indexPrixVente) {
      return this.matrice != null
        && indexRendement === this.matrice.indexRendementAdherent
        && indexPrixVente === this.matrice.indexPrixVenteAdherent
    },
    styleCase (tresorerie) {
      return this.bornes != null ? couleurCase(tresorerie, this.bornes) : {}
    },
    confirm () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.help-card-mobile {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}

.card.help-card-mobile {
  max-height: calc(100% - 56px);
}
.bg-titre {
  height: 70px;
}

@media (max-width: 960px) {
  .bg-titre {
    height: auto;
    padding: 12px 0;
  }
}
.card {
  border-radius: 0px !important;
  background-color: #f1f2f5;
}
.btn-close {
  position: absolute;
  right: 0;
}
.background {
  background-color: #f1f2f5;
  width: 912px;
  height: 600px;
}
.content {
  background-color: white;
  border-radius: 16px;
  width: 860px;
  max-width: 100%;
  height: 409px;
  margin: 2px auto 22px auto;
  padding: 24px;
  overflow-y: auto;
}
.tableau {
  width: 808px;
  height: 288px;
}
.matrice-vide {
  height: 288px;
}
.text-orientation-vertical {
  writing-mode: sideways-lr;
}
.matrice {
  width: 784px;
  height: 288px;
  margin: 6px;
}
.case {
  width: 130.67px;
  height: 48px;
  &.case-tl {
    border-radius: 8px 0 0 0;
  }
  &.case-tr {
    border-radius: 0 8px 0 0;
  }
  &.case-bl {
    border-radius: 0 0  0 8px;
  }
  &.case-br {
    border-radius: 0 0 8px 0;
  }
  &.titre {
    background-color: #F1F2F5;
  }
}
.background-mobile {
  background-color: #f1f2f5;
}
.content-mobile {
  background-color: white;
  width: auto;
  height: 409px;
  border-radius: 16px;
  margin: 10px;
  padding: 8px;
}
.matrice-mobile {
  width: 255px;
  height: 288px;
  margin: 6px;
}
.case-mobile {
  width: 42.5px;
  height: 48px;
  font-size: 12px;
  &.case-tl {
    border-radius: 8px 0 0 0;
  }
  &.case-tr {
    border-radius: 0 8px 0 0;
  }
  &.case-bl {
    border-radius: 0 0  0 8px;
  }
  &.case-br {
    border-radius: 0 0 8px 0;
  }
  &.titre {
    background-color: #F1F2F5;
  }
}
.menu-item-resume {
  position: relative;
  margin: 25px;
  padding: 4px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );

  &.menu-item-resume__top {
    &::after {
      bottom: -5px;
      left: calc(50% - 10px);
      right: 0;
    }
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -10;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background-color: #ffffff;
  }
}
.menu-item-resume-mobile {
  padding: 10px;
  width: 90%;
  margin: 20px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );
}
</style>
